export default __webpack_public_path__ + "772a1d631eac0466ba7cddbe5169d036.png";